<template>
  <b-button variant="primary" @click="exportSchedules" :disabled="disable_button">
    <span v-if="exporting">
      <i class="fal fa-spinner fa-spin mr-1" /> Exporting...
    </span>
    <template v-else>
      <span><i class="fa fa-plus" /> Create New Export</span>
    </template>
  </b-button>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const ResultExportRepository = LabRepositoryFactory.get("resultExport");

export default {
  name: "InstrumentRunnnerExportButton",
  mixins: [ToastNotifications],
  data() {
    return {
      exporting: false,
    };
  },
  props: {
    export_data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disable_button() {
      if (this.exporting) return true;
      if (!this.export_data.tasks) return true;
      if (!this.export_data.tasks.length) return true;
      return false;
    },
  },
  methods: {
    async exportSchedules() {
      this.exporting = true;
      try {
        console.log('EXPORT DATA',this.export_data)
        const str = this.export_data.schedulable_process_type;
        await ResultExportRepository.create({
          ...this.export_data,
          schedulable_process_type: `${str.charAt(0).toUpperCase()}${str.slice(
            1
          )}Process`,
        }).then((response) => {
          // emit event to iundicate a new export was created
          this.$emit("newResultExportCreated", response.data);

          //
          this.quickSuccessToast(
            "Export Success",
            "Scheduled samples were exported successfully."
          );
        });
      } catch ({ response }) {
        const { data, status } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error || data.message}`, {
          title: "Server Error.",
          variant: "danger",
        });
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>